/** NFT Rewards admin: linear setup assistant (after on-chain bootstrap). English copy. */

export const REWARDS_WIZARD_STEP_COUNT = 8;

export const REWARDS_WIZARD_STEPS = [
  {
    title: "Overview",
    description:
      "After bootstrap, confirm you are connected and see your project in the header. Use Refresh if tables look empty. This step focuses on the dashboard overview (tokens, RAM, deposits).",
  },
  {
    title: "Project",
    description:
      "Select the correct project and keep metadata up to date. Allowed accounts on the project must include your wallet.",
  },
  {
    title: "Tokens & RAM",
    description:
      "Check Allowed Tokens: your reward token must be listed and active. Review RAM budgets and deposits so claims can be processed.",
  },
  {
    title: "Reward pool",
    description:
      "Create or edit a reward pool: pool key, collection, reward asset, token, cooldown, pool type, and required immutable/mutable NFT filters (types 1, 5, 6). Use Check before Save Pool.",
  },
  {
    title: "Required NFT rules",
    description:
      "Configure Dependent NFTs (required immutable rules) for the selected pool. For Stake Claim pools (type 6), also set staking snap levels (nstaksnap) and review stake eligibility (nstakelig).",
  },
  {
    title: "Optional: exclusions",
    description:
      "If you use excluded assets for this project, maintain them here. You can skip this step when not needed.",
  },
  {
    title: "Verify & test",
    description:
      "Use Claim Calculator to sanity-check eligibility. Export claims/wallets from the tables when needed.",
  },
  {
    title: "Vault claim permission",
    description:
      "Set up the claimrewards permission on your project vault account so nftrewards can pay claims via inline token transfer. Download the PDF guide and complete the on-chain steps before going live.",
  },
];
